import { useMemo } from 'react';
import { useApi } from '@/api/useApi';
import { useQueryProvider } from '@/hooks';
import { QUERY_KEYS } from '@/constants/QueryKeys';
import { mapAcademicBoardExpert } from '../boutique-classroom.mappers';
import { AcademicBoardBranch, AcademicBoardExpert } from '../boutique-classroom.types';

const EMPTY_EXPERTS: AcademicBoardExpert[] = [];

export function useAcademicBoard() {
	const { ExpertControllerApi } = useApi();

	const { data, isLoading } = useQueryProvider([QUERY_KEYS.getAcademicBoardExperts], () => ExpertControllerApi.getAcademicBoardExperts(), {
		select: ({ data: response }) => response?.data ?? [],
		refetchOnWindowFocus: false
	});

	const experts = useMemo<AcademicBoardExpert[]>(() => (data ?? []).map(mapAcademicBoardExpert).filter((expert): expert is AcademicBoardExpert => expert !== null), [data]);

	const branches = useMemo<AcademicBoardBranch[]>(() => {
		const byId = new Map<number, AcademicBoardBranch>();
		experts.forEach(expert => expert.branches.forEach(branch => byId.set(branch.id, branch)));
		return Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name, 'tr'));
	}, [experts]);

	return { experts: experts.length ? experts : EMPTY_EXPERTS, branches, isLoading };
}
